<template>
    <client-page>

        <sub-visual
        sh="Machining Products"
        tabActive="CMP Retainer - Ring"
        bg="/images/sub/visual/sv2.png">
        </sub-visual>

        <section class="sub-section sub-section--first">
            <v-container>
                <h2 class="page-tit mb-lg-42">
                    CMP Retainer - Ring
                </h2>
            </v-container>

            <sub-bg-image
            src="/images/sub/products/cmp/cmp-top-img.png"
            className="h-lg-660px">
                <h3 class="tit font-weight-semibold mb-4 mb-lg-16">
                    CMP
                </h3>
                <p class="page-text-lg color-point font-weight-semibold mb-8 mb-md-50 mb-lg-84">
                    Chemical Mechanical Polishing
                </p>
                <p class="page-text color-grey-51 mb-24 mb-lg-50">
                    반도체 제조 8대 공정 중 하나로, Wafer를 화학적 반응(Chemical)과 <br class="d-none d-md-block">
                    기계적 힘(Mechanical)을 이용하여 평탄하게 연마(Polishing)하는 반도체 공정
                </p>
                <p class="color-point font-size-14 font-size-lg-16 line-height-19 font-weight-bold px-10 px-lg-20 border border-color-point mb-6 mb-lg-14" style="width: fit-content;">
                    Retainer Ring의 역할
                </p>
                <p class="font-size-14 font-size-lg-16 color-grey-51 mb-12 mb-lg-24">
                    CMP 장비 HEAD에 장착되어 CMP공정 중 Wafer의 이탈을 방지하기 위한 가이드 역할 및 <br class="d-none d-md-block">
                    Wafer의 Uniformity를 Support 하는 역할
                </p>
                <p class="color-point font-size-14 font-size-lg-16 line-height-19 font-weight-bold px-10 px-lg-20 border border-color-point mb-6 mb-lg-14" style="width: fit-content;">
                    Retainer Ring Type
                </p>
                <p class="font-size-14 font-size-lg-16 color-grey-51 mb-4 mb-lg-16">
                    <strong class="font-weight-bold color-point">Two-Body Type</strong> <br>
                    (Metal + Engineering Plastic bonding 타입) <br>
                    IST 기술로 Metal (SUS 304 or 316) 과 Engineering Plastic (PPS, PEEK, 기타 등 등)을 <br class="d-none d-md-block">
                    결합하여 Bonding Type으로 제작한 타입 Retainer Ring
                </p>
                <p class="font-size-14 font-size-lg-16 color-grey-51 mb-4 mb-lg-16">
                    <strong class="font-weight-bold color-point">One-Body Type  </strong> <br>
                    (Engineering Plastic 소재만 가능 – PPS, PEEK and 기타 등 등) <br>
                    단일 소재로 Engineering Plastic (PPS, PEEK and ect..) 을 제작한 Retainer Ring
                </p>
                <p class="font-size-14 font-size-lg-16 color-grey-51">
                    <strong class="font-weight-bold color-point">Insert Over Molding Type</strong> <br>
                    (Insert + PEEK 사출 몰딩) Insert를 삽입하여 사출하는 방식의 Retainer Ring
                </p>
            </sub-bg-image>

        </section>

        <section v-if="boards" class="sub-section">
            <v-container>
                
                <!-- S--게시판영역 -->
                <slide-primary>
                    <div v-for="board in boards" :key="board._id" class="swiper-slide">
                        <div class="pb-16 pb-lg-30 border-bottom">
                            <div class="thum-wrap">
                                <div class="thum" :style="`background-image: url(${board.thumb})`"></div>
                            </div>
                        </div>
                    </div>
                </slide-primary>
                <!-- E--게시판영역 -->

            </v-container>
        </section>

        <section class="sub-section sub-section--last">
            <v-container>
                <inquiry
                src="/images/sub/distributor/dupont/dupont-img1.png"
                name="이 광호"
                tel="031-765-2268"
                mail="khlee@ist-co.kr"
                fax="031-765-2389">
                </inquiry>
            </v-container>
        </section>

    </client-page>
</template>

<script>
import api from "@/api"
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import SubVisual from "@/components/client/ko/sub/sub-visual.vue";
import SubBgImage from "@/components/client/ko/sub/sub-bg-image.vue";
import SlidePrimary from "@/components/client/ko/sub/sub-slide-primary.vue";
import Inquiry from "@/components/client/ko/sub/sub-inquiry.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        SubBgImage,
        SlidePrimary,
        Inquiry,
    },
    data() {
        return {
            boards: null
        }
    },
    async mounted() {
        await this.init()
    },
    methods: {
        async init() {
            let { boards } = await api.v1.boards.gets({
                params: { code: "retainer" }
            })
            this.boards = boards;
        }
    }
};
</script>

<style lang="scss" scoped>
</style>